/* Today API — dispatches to the mock or the real HTTP backend. */
import { USE_MOCK_API } from './httpClient'
import * as mock from './today.mock'
import * as http from './today.http'

const impl = USE_MOCK_API ? mock : http

export const getToday = impl.getToday
